import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBillingAccountDetails } from '../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { ParticipantsState } from './participants-models';
import { beginBillingAccountDetailRequest, dispatchSetBillingAccountDetail } from './participants-slices';



export function useParticipantState(groupId: number, accountId: string) {
	const dispatch = useDispatch();
	const participantState = useSelector<TcsmStates, ParticipantsState>(state => state.participantState);

    useEffect(() => {
        if (groupId && accountId && !participantState.billingAccountDetailLoaded && !participantState.requesting) {
			dispatch(beginBillingAccountDetailRequest());
			dispatch(getBillingAccountDetails(accountId, groupId, dispatchSetBillingAccountDetail(dispatch)));

		}
	}, [groupId, accountId]);

	return participantState;
}